<ng-container *ngIf="loaded">
  <router-outlet></router-outlet>
  <app-cookie-consent></app-cookie-consent>
</ng-container>
